<template>
    <input
        v-if="
            filter.current_shortcut_key != 'is_banned'
        "
        @keypress.enter="$parent.$parent.$parent.customers_filter()"
        v-model="filter.columns[filter.current_shortcut_key]"
        :placeholder="$t('ui.general.search__key', {
            key: $t('models.attributes.customers.'+filter.current_shortcut_key)
        })"
        type="text"
    >
    </input>
</template>

<script>
export default {
    name: "CustomersFilterHeaderInputs",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.customers_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
    },
    methods: {
    },
    components: {
    }
}
</script>
